let observer: any

const UUID = Math.random().toString(36).slice(2)

export function startMonitorResources(trackFn: any) {
  try {
    observer = new PerformanceObserver((list) => {
      const entries = list.getEntries() as PerformanceResourceTiming[]
      for (const entry of entries) {
        // 若请求内容为神策自身，则不做任何处理，以免死循环
        if (entry.initiatorType === 'beacon' || entry.name.indexOf('sensors.nio.com') > -1) return

        // 若请求内容为 APM 监控，则不做任何处理，以免互相死循环
        if (entry.name.indexOf('apmplus.nio.com') > -1) return

        try {
          let url: URL | null = null
          try {
            url = new URL(entry.name)
          } catch {}

          trackFn('WebResourcePerformance', {
            web_resource_session: UUID,
            web_resource_name: entry.name,
            web_resource_initiator_type: entry.initiatorType,
            web_resource_start_time: entry.startTime,
            web_resource_duration: entry.duration,
            web_resource_json: JSON.stringify(entry.toJSON()),

            web_resource_url_pathname: url?.pathname,
            web_resource_url_search: url?.search,
            web_resource_url_host: url?.host,
          })
        } catch (error) {
          console.error('神策上报监听数据异常', error)
        }
      }
    })

    observer.observe({ entryTypes: ['resource'] })
  } catch (error) {
    console.error('开启资源请求监听异常', error)
  }
}
